import React from "react";
import i18n from "../../../i18n";
import { Metrics } from "../../../theme/";
import Chart from "../../chart/";
import GraphCard from "../GraphCard";
import DataPercentList from "../../list/DataPercentList";
import { MathUtil, isFunction } from "../../../util";
import { GraphDataMaker } from "../../../util/helper/graph";
import OrgUtil from "../../../util/organize";
import GenericChart from "../generics/index";

export default (props)=>{
	const { data, previousData } = props;
	const mutateObject = GraphDataMaker.createReturningObject(data);
	const previousMutateObject = GraphDataMaker.createReturningObject(previousData);
	return <GenericChart.ReportPieObjectChart 
		header={i18n.t("returning_user")} 
		{...props} 
		data={mutateObject} 
		previousData={previousMutateObject} 
	/>;
};


// WEBPACK FOOTER //
// ./src/components/report/stress/ReturningPieGraph.js